export class WaterfallItem2 {
    public seqColor: string;
    public seqBottom: number;
    public seqHeight: number;
    public absColor: string;
    public absBottom: number;
    public absHeight: number;

    public maxHeight() {
        return this.seqHeight > this.absHeight ? this.seqHeight : this.absHeight;
    }
}